import React, { useState } from "react";
import { fileRead } from "lib/common";
import { ButtonLike, CSVIcon, UploadIcon } from "@atsent/components";
import { Spinner } from "components/atom/Spinner";

export const Upload = ({
  loading,
  setLoading,
  setFile,
  setCurrentFile,
}: any) => {
  const [style, setStyle] = useState(false);

  const handleFileRead = async (e: any) => {
    const { files } = e.dataTransfer ?? e.target;
    if (files.length > 1) {
      console.log("only one file");
      return;
    }
    const file = files[0];
    if (file.type !== "text/csv") {
      console.log("only csv");
    }
    await setLoading(true);
    const data: unknown[] = await fileRead(file);
    await setCurrentFile(data);
    await setFile({
      title: file.name,
      size: file.size,
      data,
      length: data.reduce((accm, curr) => {
        try {
          // @ts-ignore
          return curr.length > accm ? curr.length : accm;
        } catch {
          return accm;
        }
      }, 1),
    });
    await setLoading(false);
  };

  return (
    <div
      className={`upload`}
      onDragOver={(e) => {
        e.stopPropagation();
        e.preventDefault();
        setStyle(true);
      }}
    >
      <label className={"iconUpload"} htmlFor={"upload"}>
        <input
          type="file"
          id={"upload"}
          accept={".tsv, .csv"}
          onChange={(e) => handleFileRead(e)}
          disabled={loading}
        />
        <CSVIcon cx={"resize-icon"} />
      </label>
      <span>
        CSV 파일을 드래그하거나 아래의 버튼을 통해 파일을 지정해 주세요.
      </span>
      <span>(최대 25MB)</span>
      {loading ? (
        <ButtonLike cx={"uploadButton fake"}>
          <Spinner bgColor={"black"} />
        </ButtonLike>
      ) : (
        <label className={"uploadButton"} htmlFor={"btn"}>
          <input
            type="file"
            id={"btn"}
            accept={".tsv, .csv"}
            onChange={(e) => handleFileRead(e)}
          />
          <UploadIcon />
          <span>업로드</span>
        </label>
      )}
      {style && (
        <div
          className={"bg"}
          style={{
            backgroundColor: "rgba(var(--black-rgb),0.4)",
            backdropFilter: "blur(2px)",
          }}
          onDragLeave={() => {
            setStyle(false);
          }}
          onDrop={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setStyle(false);
            handleFileRead(e);
          }}
        />
      )}
    </div>
  );
};
